import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Input,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
 
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { reportmanageService } from "../../../services/reportmanageService";
import { usermanageService } from "../../../services/usermanageService";

const ccrpMisReport = () => {
  const [reportData, setReportData] = useState([]);
  const [managerList, setManagerList] = useState([]);
  const [selectedManager, setSelectedManager] = useState("");
  const [ccrp_modal,setCCRPModalOpen] = useState(false);
  const [filterMonth, setFilterMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  });
  const [loading, setLoading] = useState(false);
const [totals, setTotals] = useState({ total_amendments: 0, total_errors: 0, total_complaints: 0 });

  // Fetch Senior Managers for dropdown
  const getManagerList = async () => {
    try {
      const res = await usermanageService.getmanager_list(); // Make sure backend API exists
      if (res?.data?.users) setManagerList(res.data.users);
    } catch (error) {
      console.error("Error loading manager list", error);
    }
  };

  // Fetch MIS data
  const getReportData = async (monthValue = "", manager = "") => {
    try {
      setLoading(true);
      let startDate = "";
      let endDate = "";

      if (monthValue) {
        const [year, month] = monthValue.split("-");
        const monthNum = parseInt(month, 10);
        startDate = `${year}-${String(monthNum).padStart(2, "0")}-01`;
        const lastDay = new Date(year, monthNum, 0).getDate();
        endDate = `${year}-${String(monthNum).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
      }

      const payload = {
        start_date: startDate,
        end_date: endDate,
        manager_id: manager
      };

      console.log("MIS payload:", payload);
      const response = await reportmanageService.getCcrpMisReport(payload);

        setReportData(response.data);
        setTotals(response.totals || { total_amendments: 0, total_errors: 0, total_complaints: 0 });
      
    } catch (error) {
      console.error("Error fetching CCRP MIS:", error);
      setReportData([]);
      setTotals({ total_amendments: 0, total_errors: 0, total_complaints: 0 });
    } finally {
      setLoading(false);
    }
  };

  // Download Excel
  const downloadReport = () => {
    const [year, month] = filterMonth.split("-");
    const lastDay = new Date(year, month, 0).getDate();
    const startDate = `${year}-${month}-01`;
    const endDate = `${year}-${month}-${String(lastDay).padStart(2, "0")}`;
    reportmanageService.downloadCcrpMisReport(startDate, endDate, selectedManager);
  };

  // On component mount
  useEffect(() => {
    getManagerList();
    getReportData(filterMonth);
  }, []);

  // Handle month change
  const handleMonthChange = (e) => {
    const selectedMonth = e.target.value;
    setFilterMonth(selectedMonth);
    getReportData(selectedMonth, selectedManager);
  };

  // Handle manager filter change
  const handleManagerChange = (e) => {
    const selected = e.target.value;
    setSelectedManager(selected);
    getReportData(filterMonth, selected);
  };
  const [ccrpMisData, setccrpMisData]= useState([])
  const getCCRPData = async (type,client_name,date_of_complaint) => {
      try {
       
        let startDate = "";
        let endDate = "";

        if (filterMonth) {
          const [year, month] = filterMonth.split("-");
          const monthNum = parseInt(month, 10);
          startDate = `${year}-${String(monthNum).padStart(2, "0")}-01`;
          const lastDay = new Date(year, monthNum, 0).getDate();
          endDate = `${year}-${String(monthNum).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
        }

        const payload = {
          start_date: startDate,
          end_date: endDate,
          manager_id: selectedManager,
          type:type,
          client_name:client_name,
          date_of_complaint:date_of_complaint
        };

        console.log("MIS payload:", payload);
        const response = await reportmanageService.getCCRPMisData(payload);

          setccrpMisData(response.data);
          setCCRPModalOpen(true)
         
        
      } catch (error) {
        console.error("Error fetching CCRP MIS:", error);
        setccrpMisData([]);
       
      } finally {
        
      }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mb-3">
          <Col>
            <h2>CCRP MIS Report</h2>
          </Col>
        </Row>

        <Card className="shadow">
          <CardHeader className="d-flex flex-wrap align-items-center justify-content-between">
            {/* Manager Filter */}
            <div className="col-md-3 mb-2">
  <select
    className="form-control"
    name="manager"
    onChange={handleManagerChange}
    value={selectedManager}
  >
    <option value="">All Managers</option>
    {managerList.map((mgr) => (
      <option key={mgr.value} value={mgr.value}>
        {mgr.label}
      </option>
    ))}
  </select>
</div>

            {/* Month Filter + Refresh */}
            <div className="d-flex col-md-4 mb-2">
              <Input
                type="month"
                name="month"
                value={filterMonth}
                onChange={handleMonthChange}
                className="form-control"
              />
              &nbsp;&nbsp;
              <Button
                color="primary"
                onClick={() => getReportData(filterMonth, selectedManager)}
              >
                Refresh
              </Button>
            </div>

            {/* Download Excel */}
            <Col xs={2}>
              <Button
                color="success"
                onClick={downloadReport}
                title="Download MIS Report"
              >
                <i className="fas fa-download" style={{ fontSize: "14px" }}></i>{" "}
                Export
              </Button>
            </Col>
          </CardHeader>

          {/* Table */}
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr >
                <th>Reviewer Name</th>
                <th>Error Raised By</th>
                <th>Client Name</th>
                <th>Date of Complaint</th>
                <th>Total Amendments</th>
                <th>Total Errors</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="6" className="text-center">Loading...</td></tr>
              ) : reportData.length > 0 ? (
                <>
                  {reportData.map((item, i) => (
                    <tr className={
                      i % 2 === 0
                        ? "blue-row"
                        : i % 3 === 0
                        ? "purple-row"
                        : "orange-row"
                    } key={i}>
                      <td>{item.manager_name || "-"}</td>
                      <td>{item.raised_by_name || "-"}</td>
                      <td>{item.client_name || "-"}</td>
                      <td>{item.date_of_complaint}</td>
                      <td onClick={()=>getCCRPData('A',item.client_name,item.date_of_complaint)} style={{'cursor':"pointer"}}>{item.total_amendments}</td>
                      <td onClick={()=>getCCRPData('E',item.client_name,item.date_of_complaint)}>{item.total_errors}</td>
                    </tr>
                  ))}
                  {/* ✅ Totals Row */}
                  <tr className="yellow-row" >
                    <td colSpan="4" className="text-end">Cumulative Total:</td>
                    <td>{totals.total_amendments}</td>
                    <td>{totals.total_errors}</td>
                  </tr>
                </>
              ) : (
                <tr><td colSpan="6" className="text-center">No CCRP received</td></tr>
              )}
            </tbody>
          </Table>
          {/* {!loading && (reportData.length > 0) && (
            <div className="p-3 text-end">
              <strong>Total Complaints (Amendments + Errors):</strong> {totals.total_complaints}
            </div>
          )} */}
        </Card>
         <Modal  className="taskdetailmodal"  isOpen={ccrp_modal} scrollable={true}>
                    <div className=" modal-header">
                      <h5 className=" modal-title" id="exampleModalLabel">
                      CCRP MIS DATA
                      </h5>
                      <button aria-label="Close" className=" close" type="button" onClick={() => setCCRPModalOpen(!ccrp_modal)}>
                        <span aria-hidden={true}>×</span>
                      </button>
                    </div>
                    <ModalBody>
                    {ccrpMisData.length > 0 ?
                      <Form role="form" id="add_checklist_form" > 
                      <Table style={{width:"100%"}}>
                        <thead>
                          <tr>
                            <th >Client</th>
                            <th >Sub Client</th>
                            <th >Feedback</th>
                            <th >Date</th>
                            <th > Manager</th>
                           
                            <th>Error Raised by</th>
                            <th>QA Status</th>
                            <th>Manager Status</th>
                            <th>Root Cause</th>
                            <th>Action Items</th>
                            <th>Materiality</th>
                            <th>CCRP Meeting date</th>
                          </tr>
                        </thead>
                        <tbody>
                        {ccrpMisData.length > 0 && ccrpMisData  ? (
                                ccrpMisData.map((list, i) => (
                        <tr key={i} className={((i % 2 == 0)? 'blue-row':(i % 3 == 0)?'purple-row':'orange-row') }>
                          <td>{list.name}</td>
                          <td>{list.sub_client}</td>
                          <td>{list.comment}</td>
                          <td>{list.date}</td>
                          <td>{list.manager}</td>
                          <td>{list.raised_error_by}</td>
                          <td>{list.status}</td>
                          <td>{list.final_status}</td>
                          <td>{list.root_cause}</td>
                          <td>{list.action_plan}</td>
                          <td>{list.materiality}</td>
                          <td>{list.ccrp_meeting_date}</td>
                          
                         
                        </tr>
                          ))
                          ) : (
                           <tr>
                           <td>No Data Found</td>
                           </tr>
                         )}
                        
                    
                        </tbody>
                      </Table>
                       
                      </Form> 
                  : <h3>No Data Found!</h3> }  
                    </ModalBody>
                  </Modal>
      </Container>
    </>
  );
};

export default ccrpMisReport;
